import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  GetCities_cities as GetCitiesCityGenerated,
  GetCities as GetCitiesGenerated,
  GetCitiesVariables as GetCitiesVariablesGenerated,
} from "core/queries/__generated__/GetCities";

export interface GetCitiesResponse extends GetCitiesGenerated {}
export interface GetCitiesVariables extends GetCitiesVariablesGenerated {}
export interface GetCitiesCity extends GetCitiesCityGenerated {}

export const getCities = gql`
  query GetCities($withAsanaOpsProjectIdOnly: Boolean = true) {
    cities(withAsanaOpsProjectIdOnly: $withAsanaOpsProjectIdOnly) {
      id
      name
      abbreviation
    }
  }
`;

export interface UseGetCitiesQueryOptions {
  skip: boolean;
  variables: GetCitiesVariables;
}

export const useGetCitiesQuery = ({
  skip = false,
  variables,
}: UseGetCitiesQueryOptions) =>
  useQuery<GetCitiesResponse, GetCitiesVariables>(getCities, {
    skip,
    variables,
  });
